import Image from 'next/image'
import cn from 'classnames'
import Link from 'next/link'
import styles from './LandingPuppyCard.module.scss'

const colors = {
  baseBlack: '#393939',
  baseGreen: '#00AD66',
}

const LandingPuppyCard = ({
  name,
  breed,
  gender,
  salePrice,
  location,
  discountPrice,
  slug,
  img,
  alt,
  discount,
}) => (
  <div className={styles.breedStatePuppyCard}>
    <Link href={`/puppy/${slug}`}>
      <div className={styles.cardImage}>
        <Image
          style={{ borderRadius: 8 }}
          quality={50}
          src={img}
          alt={alt}
          fill
        />
        {location && (
          <div className={styles.location}>
            <p className={styles.locationInfo}>
              <img
                className={styles.locationImg}
                src="/puppy/location.svg"
                alt="Location pin icon"
              />
              {location}
            </p>
          </div>
        )}
      </div>
    </Link>
    <div className={styles.dogInfo} style={{ paddingTop: 5 }}>
      <Link href={`/puppy/${slug}`} className={styles.name}>
        {name}
      </Link>
      <p
        className={styles.price}
        style={{ color: discount ? colors.baseGreen : colors.baseBlack }}
      >
        {discountPrice}
      </p>
    </div>
    <div className={styles.dogInfo}>
      <p className={styles.attribute}>{`${breed} | ${gender}`}</p>
      {discount && (
        <p className={cn(styles.attribute, styles.strike)}>{salePrice}</p>
      )}
    </div>
  </div>
)

export default LandingPuppyCard
